import styled from "styled-components";
import theme from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background-color: ${theme.colors.palete.brownDark};
  flex-direction: column;
  .links-container {
    display: flex;
    flex-direction: row;
    margin-top: auto;
    margin-left: 2.5vw;
    margin-bottom: 3.5vh;
    .link-item {
      color: white;
      cursor: pointer;
    }
  }
`;

export const LoginBox = styled.div`
  margin: 0 15%;
  width: 25%;
  padding: 2rem;
  background-color: ${theme.colors.brown.capivaraLightAux};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  place-self: center;
  position: fixed;
  @media (${theme.devices.tablet}) {
    padding: 1.5rem;
    width: 100%;
  }
  @media (${theme.devices.laptopL}) {
    padding: 1.5rem;
    width: 100%;
  }
`;

export const DivComponentEmail = styled.div`
  color: black;
  p {
    text-align: center;
    margin-bottom: 25px;
  }

  svg {
    color: red;
  }

  div {
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    margin-left: 5px;
    color: red;
  }
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 250px;
    height: auto;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  background-color: ${theme.colors.brown.primary};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 3vh;
  &:hover {
    background-color: ${theme.colors.brown.capivaraLight};
  }
`;

export const ExtrasContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  .anchor {
    width: fit-content;
    align-self: start;
    margin-top: 5px;
    font-size: 12px;
  }
  .btns-account-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 1vh;
  }
  .btns-row-account-container {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    margin-top: 1vh;
  }
`;
export const ButtonAccount = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  background-color: ${theme.colors.brown.capivaraLight};
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  color: black;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
`;
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${theme.colors.palete.brownDark};
  color: white;
`;
export const ContinueLogin = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2vh;
  .welcome {
    font-size: ${theme.fontSize.md};
    font-weight: 700;
    margin-bottom: 10px;
    align-self: center;
  }
`;
export const RadioContainer = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 5px;

  label {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const UserTypeContainer = styled.div``;
